import { render, staticRenderFns } from "./PackageAmountEdit.vue?vue&type=template&id=876c48a4&"
import script from "./PackageAmountEdit.vue?vue&type=script&lang=js&"
export * from "./PackageAmountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports